import { createContext, useContext } from 'react'

// Création du contexte avec des valeurs par défaut
export const InterventionFormContext = createContext({
  // Fonctions de gestion des erreurs
  getErrorMessage: () => '',
  hasError: () => false,
  
  // Données du formulaire
  control: null,
  intervention: null,
  isLoading: false,
  
  // Fonctions
  handleNewPrestataire: () => {}
})

// Hook personnalisé pour utiliser le contexte
export const useInterventionForm = () => {
  const context = useContext(InterventionFormContext)
  
  if (!context) {
    throw new Error('useInterventionForm doit être utilisé à l\'intérieur d\'un InterventionFormProvider')
  }
  
  return context
}